import styles from './stack.module.scss';
import MaterialStack from '@mui/material/Stack';

/* eslint-disable-next-line */
export interface StackProps {
  children: any,
  // component?: any,
  direction?: 'column-reverse' | 'column' | 'row-reverse' | 'row',
  divider?: any,
  spacing?: number,
  sx?: any
}

export function Stack(props: StackProps) {
  return (
    <MaterialStack
      direction={props.direction}
      divider={props.divider}
      spacing={props.spacing}
      sx={props.sx}>
      {props.children}
    </MaterialStack>
  );
}

export default Stack;